import { Component, EventEmitter, Output } from "@angular/core";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSpinModule } from "ng-zorro-antd/spin";

@Component({
    selector: 'app-stock-item-einvoice-required-modal',
    templateUrl: './stock-item-einvoice-required-modal.component.html',
    standalone: true,
    imports:[
        NzModalModule
    ]
})
export class StockItemEInvoiceRequiredModalComponent {
    modalVisible = false;    
    @Output() readonly confirm = new EventEmitter<boolean>();

    constructor (){}

    show() {
        this.modalVisible = true;
    }

    handleOk() {
        this.confirm.emit(true);
        this.modalVisible = false;
    }

    handleCancel() {
        this.confirm.emit(false);
        this.modalVisible= false;
    }
}